/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const listChildDevices = /* GraphQL */ `
  query ListChildDevices($path: String!) {
    listChildDevices(path: $path) {
      Child_DeviceID
      device_href
      Device_Type
      DeviceName
      devicesource
      DoorForcedMasked
      DoorHeldMasked
      Parent_DeviceID
      SegmentID
      Subchild_DeviceID
      Masked
      Mode
    }
  }
`;
export const listDeviceStatusForSites = /* GraphQL */ `
  query ListDeviceStatusForSites(
    $queryStringParameters: ListDeviceStatusForSitesInput!
  ) {
    listDeviceStatusForSites(queryStringParameters: $queryStringParameters) {
      device_key
      parent_id
      child_id
      subchild_id
      site_code
      device_type
      masked
      masked_timestamp
      intrusion_report
      intrusion_report_timestamp
      alarm
      alarm_timestamp
      line_error
      line_error_timestamp
      open_line
      open_line_timestamp
      shorted_line
      shorted_line_timestamp
      grounded_loop
      grounded_loop_timestamp
      relay_contact
      relay_contact_timestamp
      comm_loss
      comm_loss_timestamp
      comm_loss_host
      comm_loss_host_timestamp
      door_forced
      door_forced_timestamp
      door_held
      door_held_timestamp
      reader_mode
      reader_mode_timestamp
      full_panel_download
      full_panel_download_timestamp
      cabinet_tamper
      cabinet_tamper_timestamp
      power_failure
      power_failure_timestamp
      door_held_masked
      door_held_masked_timestamp
      door_forced_masked
      door_forced_masked_timestamp
      comm_path
      comm_path_timestamp
      last_update_epoch_utc
    }
  }
`;
export const listFacmanUserSites = /* GraphQL */ `
  query ListFacmanUserSites(
    $sitename: String
    $groupname: String
    $username: String
    $employeeId: Int
  ) {
    listFacmanUserSites(
      sitename: $sitename
      groupname: $groupname
      username: $username
      employeeId: $employeeId
    ) {
      sitesTotal
      sites {
        siteId
        siteName
        region
        siteType
      }
      error
    }
  }
`;
export const listSigInfraUserSites = /* GraphQL */ `
  query ListSigInfraUserSites($path: String!) {
    listSIGInfraUserSites(path: $path) {
      SiteCode
      AccessLevelName
      BadgeKey
      BadgeID
      Login
      Region
    }
  }
`;
export const getDeviceStatus = /* GraphQL */ `
  query GetDeviceStatus($queryStringParameters: GetDeviceStatusInput!) {
    getDeviceStatus(queryStringParameters: $queryStringParameters) {
      device_key
      parent_id
      child_id
      subchild_id
      site_code
      device_type
      masked
      masked_timestamp
      intrusion_report
      intrusion_report_timestamp
      alarm
      alarm_timestamp
      line_error
      line_error_timestamp
      open_line
      open_line_timestamp
      shorted_line
      shorted_line_timestamp
      grounded_loop
      grounded_loop_timestamp
      relay_contact
      relay_contact_timestamp
      comm_loss
      comm_loss_timestamp
      comm_loss_host
      comm_loss_host_timestamp
      door_forced
      door_forced_timestamp
      door_held
      door_held_timestamp
      reader_mode
      reader_mode_timestamp
      full_panel_download
      full_panel_download_timestamp
      cabinet_tamper
      cabinet_tamper_timestamp
      power_failure
      power_failure_timestamp
      door_held_masked
      door_held_masked_timestamp
      door_forced_masked
      door_forced_masked_timestamp
      comm_path
      comm_path_timestamp
      last_update_epoch_utc
    }
  }
`;
export const getUserPrefs = /* GraphQL */ `
  query GetUserPrefs($username: String!) {
    getUserPrefs(username: $username) {
      username
      inputs {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      lastSite {
        sitename
        siteRegion
      }
      readersAlarms {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      readersModes {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      site
      sites {
        sitename
        siteRegion
      }
    }
  }
`;
